import { render, staticRenderFns } from "./FilteredListWithAddButton.vue?vue&type=template&id=84d4ecbc&lang=pug&"
import script from "./FilteredListWithAddButton.vue?vue&type=script&lang=ts&"
export * from "./FilteredListWithAddButton.vue?vue&type=script&lang=ts&"
import style0 from "./FilteredListWithAddButton.vue?vue&type=style&index=0&id=84d4ecbc&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports